<template>
  <div class="register">
    <div class="background">
      <div>
        <b-button href="/" class="btn-back" variant="link">
          <img
            src="@/assets/Login/voltar.png"
            alt="Botão com seta para esquerda indicando para voltar a página anterior"
          />
          Voltar
        </b-button>
      </div>

      <div>
        <b-container>
          <b-row>
            <b-card>
              <b-col
                style="padding: 30px"
                lg="12"
                class="pb-4 d-flex justify-content-center"
              >
                <img
                  class="logo"
                  src="@/assets/Login/COMP WEEK.svg"
                  alt="Imagem logo da CompWeek, sendo as letras da mesma em caixa alta"
                />
              </b-col>
              <b-alert v-model="showAlert" show variant="light" dismissible>
                <b-icon-exclamation-triangle-fill
                  variant="danger"
                  v-if="alertType == 'error'"
                />
                <b-icon v-else icon="check" variant="success" />
                {{ textAlert }}
              </b-alert>

              <b-form @submit="onSignUp">
                <b-form-group>
                  <label class="label">Nome Completo</label>
                  <b-form-input
                    type="text"
                    required
                    placeholder
                    v-model="$v.form.name.$model"
                    :state="validateState('name')"
                    class="form-control"
                  ></b-form-input>
                </b-form-group>

                <b-form-group>
                  <label class="label">Email</label>
                  <b-form-input
                    type="email"
                    required
                    v-model="$v.form.email.$model"
                    :state="validateState('email')"
                    class="form-control"
                  ></b-form-input>
                </b-form-group>

                <b-form-group>
                  <label class="label">LinkedIn (opcional)</label>
                  <b-form-input
                    type="text"
                    v-model="$v.form.linkedIn.$model"
                    :state="validateState('linkedIn')"
                    class="form-control"
                  ></b-form-input>
                </b-form-group>

                <b-form-group>
                  <label class="label">CPF</label>
                  <b-form-input
                    v-mask="'###.###.###-##'"
                    type="text"
                    required
                    v-model="$v.form.cpf.$model"
                    :state="validateState('cpf')"
                    class="form-control"
                  ></b-form-input>
                </b-form-group>

                <b-form-group>
                  <label class="label">Senha</label>
                  <b-form-input
                    type="password"
                    required
                    v-model="$v.form.password.$model"
                    :state="validateState('password')"
                    class="form-control"
                  ></b-form-input>
                </b-form-group>

                <b-form-group>
                  <label class="label">Confirmar Senha</label>
                  <b-form-input
                    type="password"
                    required
                    v-model="$v.form.passwordVerify.$model"
                    :state="validateState('passwordVerify')"
                    class="form-control"
                  ></b-form-input>
                </b-form-group>

                <b-form-checkbox
                  type="checkbox"
                  class="pb-4"
                  v-model="form.shareData"
                  :value="true"
                  :unchecked-value="false"
                >
                  Li e concordo com os
                  <a
                    href="https://drive.google.com/file/d/1uh8olhgNZSQEEmqkwnha1VJw1OCPsRMv/view?usp=sharing"
                    target="_blank"
                  >
                    <u>termos de uso</u>.
                  </a>
                </b-form-checkbox>

                <b-form-checkbox
                  type="checkbox"
                  class="pb-4"
                  v-model="status"
                  value="true"
                  unchecked-value="false"
                  >Estudo na UFLA (opcional)</b-form-checkbox
                >

                <div v-if="status == 'true'">
                  <b-form-group>
                    <label class="label">Matrícula</label>
                    <b-form-input
                      type="text"
                      required
                      v-model="$v.form.studentCode.$model"
                      :state="validateState('studentCode')"
                      class="form-control"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group class="pb-3">
                    <label class="label">Curso</label>
                    <b-form-select
                      v-model="$v.form.course.$model"
                      :state="validateState('course')"
                      :options="cursos"
                      size="sm"
                      class="form-control"
                    />
                  </b-form-group>

                  <b-form-group class="pb-3">
                    <label class="label">Previsão de Formatura</label>
                    <b-form-select
                      v-model="$v.form.graduationEstimate.$model"
                      :state="validateState('graduationEstimate')"
                      size="sm"
                      class="form-control"
                    >
                      <b-form-select-option value="Dez / 2024"
                        >Dez / 2024</b-form-select-option
                      >
                      <b-form-select-option value="Jul / 2025"
                        >Jul / 2025</b-form-select-option
                      >
                      <b-form-select-option value="Dez / 2025"
                        >Dez / 2025</b-form-select-option
                      >
                      <b-form-select-option value="Jul / 2026"
                        >Jul / 2026</b-form-select-option
                      >
                      <b-form-select-option value="Dez / 2026"
                        >Dez / 2026</b-form-select-option
                      >
                      <b-form-select-option value="Jul / 2027"
                        >Jul / 2027</b-form-select-option
                      >
                      <b-form-select-option value="Dez / 2027"
                        >Dez / 2027</b-form-select-option
                      >
                      <b-form-select-option value="Jul / 2028"
                        >Jul / 2028</b-form-select-option
                      >
                      <b-form-select-option value="Dez / 2028"
                        >Dez / 2028</b-form-select-option
                      >
                      <b-form-select-option value="Jul / 2029"
                        >Jul / 2029</b-form-select-option
                      >
                      <b-form-select-option value="Dez / 2029"
                        >Dez / 2029</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group class="pb-3">
                    <label class="label">Período de Graduação</label>
                    <b-form-select
                      v-model="$v.form.graduationPeriod.$model"
                      :state="validateState('graduationPeriod')"
                      size="sm"
                      class="form-control"
                    >
                      <b-form-select-option value="1° periodo"
                        >1° periodo</b-form-select-option
                      >
                      <b-form-select-option value="2° periodo"
                        >2° periodo</b-form-select-option
                      >
                      <b-form-select-option value="3° periodo"
                        >3° periodo</b-form-select-option
                      >
                      <b-form-select-option value="4° periodo"
                        >4° periodo</b-form-select-option
                      >
                      <b-form-select-option value="5° periodo"
                        >5° periodo</b-form-select-option
                      >
                      <b-form-select-option value="6° periodo"
                        >6° periodo</b-form-select-option
                      >
                      <b-form-select-option value="7° periodo"
                        >7° periodo</b-form-select-option
                      >
                      <b-form-select-option value="8° periodo"
                        >8° periodo</b-form-select-option
                      >
                      <b-form-select-option value="9° periodo"
                        >9° periodo</b-form-select-option
                      >
                      <b-form-select-option value="10° periodo"
                        >10° periodo</b-form-select-option
                      >
                      <b-form-select-option value="11° periodo"
                        >11° periodo</b-form-select-option
                      >
                      <b-form-select-option value="12° periodo"
                        >12° periodo</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>
                </div>

                <b-form-checkbox
                  type="checkbox"
                  class="pb-4"
                  v-model="status2"
                  value="true"
                  unchecked-value="false"
                  >Sou de outra Universidade (opcional)</b-form-checkbox
                >

                <div v-if="status2 == 'true'">
                  <b-form-group>
                    <label class="label">Universidade</label>
                    <b-form-input
                      type="text"
                      required
                      v-model="$v.form.institution.$model"
                      :state="validateState('institution')"
                      class="form-control"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group class="pb-3">
                    <label class="label">Curso</label>
                    <b-form-input
                      type="text"
                      required
                      v-model="$v.form.courseOther.$model"
                      :state="validateState('courseOther')"
                      class="form-control"
                    />
                  </b-form-group>

                  <b-form-group class="pb-3">
                    <label class="label">Previsão de Formatura</label>
                    <b-form-select
                      v-model="$v.form.graduationEstimate.$model"
                      :state="validateState('graduationEstimate')"
                      size="sm"
                      class="form-control"
                    >
                      <b-form-select-option value="Dez / 2024"
                        >Dez / 2024</b-form-select-option
                      >
                      <b-form-select-option value="Jul / 2025"
                        >Jul / 2025</b-form-select-option
                      >
                      <b-form-select-option value="Dez / 2025"
                        >Dez / 2025</b-form-select-option
                      >
                      <b-form-select-option value="Jul / 2026"
                        >Jul / 2026</b-form-select-option
                      >
                      <b-form-select-option value="Dez / 2026"
                        >Dez / 2026</b-form-select-option
                      >
                      <b-form-select-option value="Jul / 2027"
                        >Jul / 2027</b-form-select-option
                      >
                      <b-form-select-option value="Dez / 2027"
                        >Dez / 2027</b-form-select-option
                      >
                      <b-form-select-option value="Jul / 2028"
                        >Jul / 2028</b-form-select-option
                      >
                      <b-form-select-option value="Dez / 2028"
                        >Dez / 2028</b-form-select-option
                      >
                      <b-form-select-option value="Jul / 2029"
                        >Jul / 2029</b-form-select-option
                      >
                      <b-form-select-option value="Dez / 2029"
                        >Dez / 2029</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group class="pb-3">
                    <label class="label">Período de Graduação</label>
                    <b-form-select
                      v-model="$v.form.graduationPeriod.$model"
                      :state="validateState('graduationPeriod')"
                      size="sm"
                      class="form-control"
                    >
                      <b-form-select-option value="1° periodo"
                        >1° periodo</b-form-select-option
                      >
                      <b-form-select-option value="2° periodo"
                        >2° periodo</b-form-select-option
                      >
                      <b-form-select-option value="3° periodo"
                        >3° periodo</b-form-select-option
                      >
                      <b-form-select-option value="4° periodo"
                        >4° periodo</b-form-select-option
                      >
                      <b-form-select-option value="5° periodo"
                        >5° periodo</b-form-select-option
                      >
                      <b-form-select-option value="6° periodo"
                        >6° periodo</b-form-select-option
                      >
                      <b-form-select-option value="7° periodo"
                        >7° periodo</b-form-select-option
                      >
                      <b-form-select-option value="8° periodo"
                        >8° periodo</b-form-select-option
                      >
                      <b-form-select-option value="9° periodo"
                        >9° periodo</b-form-select-option
                      >
                      <b-form-select-option value="10° periodo"
                        >10° periodo</b-form-select-option
                      >
                      <b-form-select-option value="11° periodo"
                        >11° periodo</b-form-select-option
                      >
                      <b-form-select-option value="12° periodo"
                        >12° periodo</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>
                </div>

                <b-col class="d-flex justify-content-center pb-3">
                  <Cadastrar
                    :disabled="$v.$invalid"
                    :showSpinner="showSpinner"
                    texto="Cadastrar"
                  />
                </b-col>
              </b-form>
            </b-card>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import { Signup } from "@/services/api/Auth";
import { listarCursos } from "@/services/api/Cursos";
import { validationMixin } from "vuelidate";
import { mask } from "vue-the-mask";
import {
  required,
  email,
  sameAs,
  /* minLength*/
} from "vuelidate/lib/validators";
import fieldValidation from "@/utils/FieldValidation";
import cpfValidation from "@/utils/CpfValidation";
import Cadastrar from "@/components/Button-fill";

export default {
  directives: { mask },
  components: {
    Cadastrar,
  },
  mixins: [validationMixin, fieldValidation],
  data() {
    return {
      textAlert: "",
      showAlert: false,
      alertType: "",
      showSpinner: false,
      status: "false",
      status2: "false",
      cursos: [{ value: "", text: "Selecione um curso", disabled: true }],
      // formatura: [{ value: "", text: "Selecione uma previsão de formatura", disabled: true }],
      form: {
        name: "",
        email: "",
        cpf: "",
        password: "",
        passwordVerify: "",
        studentCode: "",
        course: "",
        shareData: false,
        linkedIn: "",
        institution: "",
        courseOther: "",
        graduationEstimate: "",
        graduationPeriod: "",
        enableCalendar: false,
      },
    };
  },
  validations: {
    form: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
      cpf: {
        required,
        cpfValidation,
      },
      password: {
        required,
        //minLength: minLength(8)
      },
      passwordVerify: {
        required,
        //minLength: minLength(8),
        sameAs: sameAs("password"),
      },
      studentCode: {},
      course: {},
      linkedIn: {},
      graduationEstimate: {},
      graduationPeriod: {},
      institution: {},
      courseOther: {},
      shareData: {
        isValid: (value) => {
          return value == true;
        },
      },
      enableCalendar: {},
    },
  },
  beforeCreate() {
    listarCursos()
      .then((res) => {
        this.cursos = [...this.cursos, ...res.data];
      })
      .catch((err) => {
        console.error("Erro ao obter cursos", err.response);
      });
  },
  watch: {
    status(val) {
      if (val && this.status2) {
        this.status2 = !this.status2;
      }
    },
    status2(val) {
      if (val && this.status) {
        this.status = !this.status;
      }
    },
  },
  methods: {
    onSignUp(evt) {
      evt.preventDefault();
      this.showSpinner = true;

      Signup(this.form)
        .then(() => {
          this.showAlert = true;
          this.alertType = "info";
          this.textAlert =
            "Usuário cadastrado. Verifique seu email (inclusive Spam) para ativar sua conta";
          window.scrollTo(0, 0);
          this.showSpinner = false;
          this.form.name = "";
          this.form.email = "";
          this.form.linkedIn = "";
          this.form.cpf = "";
          this.form.password = "";
          this.form.passwordVerify = "";
          this.form.shareData = false;
          this.status = false;
          this.status2 = false;
          this.form.studentCode = "";
          this.form.course = "";
          this.form.graduationEstimate = "";
          this.form.graduationPeriod = "";
          this.form.institution = "";
          this.form.courseOther = "";
          this.form.enableCalendar = false;
          this.$v.form.$reset();
        })
        .catch((error) => {
          console.error("erro ao fazer login", error.response);
          this.showAlert = true;
          this.alertType = "error";
          this.textAlert = error.response.data.error;
          this.showSpinner = false;
          window.scrollTo(0, 0);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.alert-light {
  box-shadow: 1px 2px 6px 1px #00000029;
}
.register {
  background-color: #fcfcfc;
  font-family: Roboto;
}
.background {
  background-image: url("~@/assets/Login/LinhaRoxa.svg");
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: top;
  margin-top: 0px;
}

.svg {
  transform: rotate(90deg);
  width: 38px;
  height: 24px;
}
.btn-back {
  text-decoration: none;
  font-size: 17px;
  font-family: Roboto, sans-serif;
  color: #030303 !important;
  margin-left: 5%;
  padding-top: 25px;
  display: inline-block;
}
.container {
  padding: 25px;
}
.card {
  border: 0px;
  background-color: #ffffff;
  box-shadow: 1px 6px 6px 1px #00000029;
  border-radius: 25px;
  margin: 0 auto;
  margin-bottom: 20px;
  width: 24rem;
}
.logo {
  width: 250px;
  height: 137px;
}
.label {
  color: #000000;
  font-family: Roboto;
}
.form-control {
  border-radius: 0rem;
  border: 1px solid #5b5b5b;
}
.login:hover {
  background-position: 100% 0;
  moz-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  -webkit-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}
.btn-hover.login {
  background-image: linear-gradient(to right, #fbb03b, #ed1c24, #ff0000);
  border-radius: 35px;
  width: 170px;
  height: 42px;
  border: none;
  background-size: 300% 100%;
}
a {
  text-decoration: none;
  color: black;
}
a:hover {
  color: rgb(117, 117, 117);
}
@media screen and (max-width: 260px) {
  .logo {
    width: 130px;
    height: 57px;
  }
}

@media screen and (width: 1024px) and (height: 1366px) {
  .card {
    margin-top: 100px;
  }
  .label {
    font-size: 20px;
  }
}
</style>
<style lang="scss" scoped>
.custom-checkbox .custom-control-label::before {
  border-radius: 50% !important;
  border-color: #5928c2 !important;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #5928c2;
  border-color: #5928c2;
  border-radius: 50%;
}
</style>
